import { ComponentType } from 'react';
import { connect } from 'react-redux';
import { Props } from './VerificationReminder';
import {
  getIsUnverified,
  getVerificationLoadingState,
} from '../../../publicSession/selectors';
import { resendVerificationEmail } from '../../../publicSession/actions';

export type StateProps = Pick<Props,
  | 'isUnverified'
  | 'isResendInProgress'
  | 'isEmailChangeInProgress'
  | 'isSendingDone'
>;
export type DispatchProps = Pick<Props, 'resendEmail'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps = (state): StateProps => Object.assign({},
  getVerificationLoadingState(state), {
    isUnverified: getIsUnverified(state)
  },
);
const mapDispatchToProps: DispatchProps = {
  resendEmail: resendVerificationEmail,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
) as (component: ComponentType<Props>) => ComponentType<OwnProps>;
